module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-07-01",
		"endpointPrefix": "marketplacecommerceanalytics",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "AWS Marketplace Commerce Analytics",
		"signatureVersion": "v4",
		"signingName": "marketplacecommerceanalytics",
		"targetPrefix": "MarketplaceCommerceAnalytics20150701"
	},
	"operations": {
		"GenerateDataSet": {
			"input": {
				"type": "structure",
				"required": [
					"dataSetType",
					"dataSetPublicationDate",
					"roleNameArn",
					"destinationS3BucketName",
					"snsTopicArn"
				],
				"members": {
					"dataSetType": {},
					"dataSetPublicationDate": {
						"type": "timestamp"
					},
					"roleNameArn": {},
					"destinationS3BucketName": {},
					"destinationS3Prefix": {},
					"snsTopicArn": {},
					"customerDefinedValues": {
						"shape": "S8"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"dataSetRequestId": {}
				}
			}
		},
		"StartSupportDataExport": {
			"input": {
				"type": "structure",
				"required": [
					"dataSetType",
					"fromDate",
					"roleNameArn",
					"destinationS3BucketName",
					"snsTopicArn"
				],
				"members": {
					"dataSetType": {},
					"fromDate": {
						"type": "timestamp"
					},
					"roleNameArn": {},
					"destinationS3BucketName": {},
					"destinationS3Prefix": {},
					"snsTopicArn": {},
					"customerDefinedValues": {
						"shape": "S8"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"dataSetRequestId": {}
				}
			}
		}
	},
	"shapes": {
		"S8": {
			"type": "map",
			"key": {},
			"value": {}
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/aws-sdk/apis/marketplacecommerceanalytics-2015-07-01.min.json
 ** module id = 1339
 ** module chunks = 0
 **/